import React from 'react';
import { styled } from '@uhg-abyss/web/tools/styled';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { usePayer } from '@src/state/payer';
import { useHeaderMenu } from '@src/state/headerMenu';
import { Button } from '@uhg-abyss/web/ui/Button';

const StyledPayerDrawerLabel = styled('span', {
  verticalAlign: 'middle',
  display: 'inline-block',
  color: '$gray8',
  fontSize: '16px',
  fontWeight: 'bold',
});

const StyledPayerSelectButton = styled(Button, {
  '&.abyss-button-root': {
    paddingLeft: 0,
    fontSize: 14,
    height: 'auto',
    boxShadow: 'none !important',
    textAlign: 'left',
  },
  '.abyss-insert-element-after': {
    paddingLeft: '6px !important',
  },
});

const StyledServicingPayerLabel = styled('span', {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '250px',
  fontSize: '16px',
  fontWeight: 'bold',
  '@media (max-width: 983px)': {
    maxWidth: '200px',
  },
});

const StyledPayerContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
});

export const PayerSelectDrawer = () => {
  const { payer } = usePayer.state();
  const { setPayer } = usePayer.actions();
  const { isPayerOpen } = useHeaderMenu.state();
  const { togglePayer } = useHeaderMenu.actions();

  const handlePayerButtonClick = () => {
    togglePayer(true);
  };

  return (
    <React.Fragment>
      <StyledPayerContainer>
        <StyledPayerDrawerLabel>Payer</StyledPayerDrawerLabel>
        <StyledPayerSelectButton
          data-testid='payer-menu'
          variant='tertiary'
          onClick={handlePayerButtonClick}
          isLoading={!payer.payerLabel}
          after={
            <IconSymbol icon='keyboard_arrow_right' color='$interactive1' />
          }
        >
          <StyledServicingPayerLabel data-testid='payer-label'>
            {payer.payerLabel}
          </StyledServicingPayerLabel>
        </StyledPayerSelectButton>
      </StyledPayerContainer>
    </React.Fragment>
  );
};
